/* Curly & Blonde free shipping bar: confetti moment + live bar in the "Item added" popup */
(function () {
  if (window.cbShipBarInit) return;
  window.cbShipBarInit = true;

  var KEY = 'cbFreeShipCelebrated';
  var COLOURS = ['#FABBCB', '#9F8FCA', '#A7E6D7', '#FDD26E', '#5A4A99'];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getFlag() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function setFlag(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }

  function pop(origin) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = document.createElement('canvas');
    var dpr = window.devicePixelRatio || 1;
    c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999';
    c.width = window.innerWidth * dpr;
    c.height = window.innerHeight * dpr;
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    ctx.scale(dpr, dpr);
    var r = origin.getBoundingClientRect();
    var pieces = [];
    [r.left + r.width * 0.15, r.left + r.width * 0.85].forEach(function (x, side) {
      for (var i = 0; i < 45; i++) {
        var a = 0.6 + Math.random() * 0.7;
        var speed = 7 + Math.random() * 7;
        pieces.push({
          x: x, y: r.top + r.height / 2,
          vx: (side ? -1 : 1) * Math.cos(a) * speed, vy: -Math.sin(a) * speed,
          w: 6 + Math.random() * 5, h: 3 + Math.random() * 3,
          rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3,
          colour: COLOURS[Math.floor(Math.random() * COLOURS.length)],
          round: Math.random() < 0.3
        });
      }
    });
    var start = performance.now();
    function frame(t) {
      var life = (t - start) / 1800;
      ctx.clearRect(0, 0, c.width, c.height);
      pieces.forEach(function (p) {
        p.vy += 0.28; p.vx *= 0.985; p.vy *= 0.985;
        p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - life);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.colour;
        if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.h, 0, Math.PI * 2); ctx.fill(); }
        else { ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); }
        ctx.restore();
      });
      if (life < 1) requestAnimationFrame(frame); else c.remove();
    }
    requestAnimationFrame(frame);
  }

  function visibleBar() {
    var bars = document.querySelectorAll('.cb-ship-bar');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].offsetParent !== null) return bars[i];
    }
    return null;
  }

  function check() {
    var bar = visibleBar();
    if (!bar) return;
    var done = bar.classList.contains('cb-ship-bar--done');
    if (done && getFlag() !== '1') { setFlag('1'); setTimeout(function () { pop(bar); }, 250); }
    else if (!done) { setFlag('0'); }
  }

  /* Popup: whenever a product is added, fetch the latest bar and drop it into the popup */
  function refreshPopupBar() {
    var slot = document.getElementById('cb-notif-ship');
    if (!slot) return;
    fetch(root + '?sections=cb-ship-bar', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data['cb-ship-bar'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var bar = tmp.querySelector('.cb-ship-bar');
        var style = tmp.querySelector('style');
        slot.innerHTML = '';
        if (style) slot.appendChild(style);
        if (bar) slot.appendChild(bar);
        requestAnimationFrame(check);
      })
      .catch(function () {});
  }

  function start() {
    check();
    new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
    var product = document.getElementById('cart-notification-product');
    if (product) {
      new MutationObserver(refreshPopupBar).observe(product, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
